export const MODE = {
  WEB: "web",
  MOBILE: "mobile",
  EXTENSION: "extension",
} as const;

export const MODE_VALUES = [MODE.WEB, MODE.MOBILE, MODE.EXTENSION] as const;

export type Mode = (typeof MODE_VALUES)[number];
